<div *ngIf="open" class="video-modal-overlay" (click)="onOverlayClick()">
  <div class="video-modal-content" (click)="$event.stopPropagation()">
    <div class="video-modal-header">
      <h2>{{ title }}</h2>
      <button
        type="button"
        class="modal-close"
        (click)="close()"
        [attr.aria-label]="'dashboard.common.close' | translate">
        ×
      </button>
    </div>
    <div class="video-modal-body">
      <div class="video-loading" *ngIf="loading">
        <ion-icon name="hourglass-outline" class="loading-icon"></ion-icon>
        <p>{{ 'dashboard.common.videoPlayer.loading' | translate }}</p>
      </div>
      <video
        *ngIf="videoUrl && !loading"
        class="video-player"
        controls
        autoplay
        playsinline
        preload="metadata"
        [src]="videoUrl">
        {{ 'dashboard.common.videoPlayer.notSupported' | translate }}
      </video>
    </div>
  </div>
</div>
